import $ from 'jquery';

$(function () {
  if ($('.js-email-preview-area').length) {
    $('.js-email-flow-change-channel').on('click', function () {
      var newChannel = $(this).data('channel');
      var previewToShow = $(
        '.js-email-preview-area[data-channel=' + newChannel.toLowerCase() + ']',
      );
      $('.js-email-preview-area').addClass('hidden');
      previewToShow.removeClass('hidden');
      $('#selected_channel').val(newChannel);
    });

    $('.js-update-email-preview-btn').click(function () {
      var channel = this.dataset.channel;
      var $iframe = $('iframe.js-email-preview-iframe:visible');
      var split = $iframe.attr('src').split('?');
      var base = split[0];
      var selector =
        '.js-dynamic-text-form-group[data-channel="' + channel + '"] *';
      var qString = $(selector).serialize() + '&selected_channel=' + channel;
      $iframe.attr('src', base + '?' + qString);
    });
  }

  $('iframe.js-email-preview-iframe').on('load', function () {
    $(this)
      .contents()
      .find('a')
      .click(function (event) {
        if ($(this).is('.js-star-anchor') && $('body.show_employee').length) {
          $(this).attr({
            target: '_blank',
            rel: 'noopener noreferrer',
          });
          return;
        }
        event.preventDefault();
        return false;
      });
  });
});
